import api from "./apiLogisticsTool.js";

export default {
  GetOperators() {
    return api.get("Operators/GetOperators");
  },  

  GetOperator(id) {
    return api.get("Operators/GetOperator/" + id);
  },

  CreateOperator(operator) {
    return api.post("Operators/CreateOperator", operator);
  },

  EditOperator(id, operator) {
    return api.put("Operators/EditOperator", id, "/", operator);
  },
  MappingsNumber(id){
    return api.get("Operators/MappingsNumber/"+id);
  },
  Delete(id){
    return api.delete("Operators/Delete/"+id);
  }
};
